/**
 * Configuration constants for the Live Topics panel (list, detail, skeletons, media, scroll).
 */

import { getQueryParam } from '@mi-front/core';

/** Polling interval for refetching live topics (ms). */
export const TRACK_REFETCH_INTERVAL_MS = 60000;

/** Polling interval for refetching live topics (ms). */
export const PANEL_REFETCH_INTERVAL_MS = 15000;

/** Max number of topics to fetch and show in the list. */
export const TOPICS_LIMIT = getQueryParam('topics_limit', 30, Number);

/** Max age for showing the "NEW" chip on a topic (15 minutes). */
export const NEW_TOPIC_MAX_AGE_MS = 15 * 60 * 1000;

/** Entity chips per row in the detail view skeleton. */
export const ENTITY_CHIPS_PER_ROW = 4;

/** Default height (px) for the topic thumbnail in the detail view. */
export const TOPIC_THUMBNAIL_HEIGHT = 120;

/** Scroll position (px) below which the list is considered "at top" for scroll-lock behavior. */
export const SCROLL_TOP_THRESHOLD_PX = 50;

/** Number of summary line skeletons in the detail view skeleton. */
export const SKELETON_SUMMARY_LINES = 6;

/** Number of skeleton list items shown while the topic list is loading. */
export const SKELETON_ITEMS_COUNT = 20;

/** Number of entity chip rows in the detail view skeleton. */
export const SKELETON_ENTITY_ROWS = 2;
